export const ROUTE_PATHS = {
  HOME: '/'
} as const;

export type RoutePathKey = keyof typeof ROUTE_PATHS;
export type RoutePath = typeof ROUTE_PATHS[RoutePathKey];
